<template>
  <div>
    <v-row v-if="showTemplates">
      <v-col sm="4" lg="3" cols="12" style="padding-bottom: 20px; max-height: 60px">
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          single-line
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col sm="4" md="3" lg="2" cols="12" style="padding-bottom: 20px">
        <v-btn
          style="width: 100%; margin: 0"
          large
          :color="colorTheme"
          class="white--text"
          v-on:click="showNewTemplate()"
        >{{ $t("newTemplate").toUpperCase() }}</v-btn>
      </v-col>
      <v-col sm="4" md="3" lg="2" cols="12" style="padding-bottom: 20px">
        <v-btn
          style="width: 100%; margin: 0"
          v-if="selectedT.length > 0"
          large
          :color="colorTheme"
          class="white--text"
          v-on:click="confirm()"
        >{{ $t("delete").toUpperCase() }}</v-btn>
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <v-data-table
          v-model="selectedT"
          :headers="headersTemplatesAT"
          :items="templatesAT"
          item-key="Id"
          :loading="loadingTableInTemplatesAT"
          :loading-text="$t('loadingTextForTable')"
          :show-select="fullVersion"
          class="elevation-1"
          :items-per-page="5"
          :search="search"
          :no-data-text="$t('noResults')"
          :footer-props="{
          'items-per-page-text': $t('rows'),
          'items-per-page-all-text': $t('all')
        }"
        >
        <template v-slot:item.CreationDate="{ item }">
          <span>{{ item.CreationDateAsText }}</span>
        </template>

        <template v-slot:item.EditionDate="{ item }">
          <span>{{ item.EditionDateAsText }}</span>
        </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              text
              small
              :color="colorTheme"
              v-on:click="showAssignView(item)"
            >{{ $t("assign").toUpperCase() }}</v-btn>
            <v-btn
              text
              small
              :color="colorTheme"
              v-if="fullVersion"
              v-on:click="editT(item)"
            >{{ $t("edit").toUpperCase() }}</v-btn>
            <v-btn
              text
              small
              :color="colorTheme"
              v-if="fullVersion"
              v-on:click="confirm(item)"
            >{{ $t("delete").toUpperCase() }}</v-btn>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ search }}".</v-alert>
          <template v-slot:footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }}
            {{ $t("of").toLowerCase() }} {{ items.itemsLength }}
          </template>
        </v-data-table>
      </v-col>
      <v-dialog v-model="dialogConfirm" hide-overlay persistent width="421px">
        <v-card>
          <v-card-title>{{ $t("confirmationT") }}</v-card-title>
          <v-divider :color="colorTheme" style="border-width: 2px;"></v-divider>
          <v-card-text
            style="padding-top: 11px;color:black;"
            v-if="selectedT.length > 1"
          >{{ $t("deleteTemplates") }}</v-card-text>
          <v-card-text style="padding-top: 11px;color:black;" v-else>{{ $t("deleteTemplate") }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="dialogConfirm = false"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="deleteTemplates()"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row style="display: contents;" v-else>
      <newTemplate></newTemplate>
    </v-row>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
export default {
  name: "templatesAT",
  components: {
    newTemplate: () => import("@/components/newTemplate")
  },
  data: () => ({
    search: "",
    selectedT: [],
    dialogConfirm: false
  }),
  created() {
    this.$store.commit("setTitle", "ALERTRUCK");

    if (this.$store.state.showTemplates) {
      this.$store.commit("setPageHeader", [
        this.$t("configTemplates").toUpperCase(),
        "",
        "",
        "",
        true
      ]);
    }
  },
  mounted() {
    this.$store.dispatch("catalogTemplatesAT");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "headersTemplatesAT",
      "templatesAT",
      "loadingTableInTemplatesAT",
      "fullVersion",
      "showTemplates"
    ])
  },
  methods: {
    showAssignView(item) {
      console.log(item);
      //this.$store.dispatch("assignTemplate", item);
      this.$router.push({ name: "assignTemplate" });
      this.$store.commit("setPageHeader", [
        this.$t("configTemplates").toUpperCase(),
        this.$t("templateAssignment").toUpperCase(),
        "",
        "",
        true
      ]);
    },
    editT(item) {
      console.log(item);
      this.$store.dispatch("getTemplateContent", item);
    },
    confirm(item) {
      this.dialogConfirm = true;
    },
    deleteTemplates() {
      this.dialogConfirm = false;
      this.selectedT = [];
      this.$store.dispatch("catalogTemplatesAT");
      //console.log('eliminada');
    },
    showNewTemplate() {
      this.$store.dispatch("newTemplate");
    }
  }
};
</script>

<style></style>